import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { UrlService } from '../state/url.service';
import { BildungszielClient } from '../integration/bildungsziel.client';

@Injectable({
  providedIn: 'root'
})
export class BerufeService {
  private readonly urlService = inject(UrlService);
  private readonly bildungszielClient = inject(BildungszielClient);

  public static readonly URL_PARAM_BERUFE = 'berufe';

  public ids$: Observable<number[]> = this.urlService
    .getQueryParameterValue(BerufeService.URL_PARAM_BERUFE)
    .pipe(
      map(
        (param) =>
          (param ?? '')
            .split(UrlService.VALUE_SEPARATOR)
            .map(Number)
            .filter(Number.isInteger)
            .filter((id) => id != 0) // '' wird zu 0
      )
    );

  public bezeichnung$: Observable<string> = this.ids$.pipe(
    distinctUntilChanged(),
    switchMap((ids) => {
      return ids.length != undefined && ids.length != 0
        ? this.bildungszielClient.getBezeichnungById(ids[0]).pipe(catchError(() => of('')))
        : of('');
    })
  );

  public isBerufssuche$: Observable<boolean> = this.ids$.pipe(map((ids) => ids.length !== 0));
}
